module.exports = __webpack_public_path__ + "static/converge4-2497f41b63b797b1e6e421c6d8ff5f6b.jpg";